import * as React from 'react';
import { Link } from 'react-router';
import styled, { css, keyframes } from 'styled-components';
import { rem, darken } from 'polished';
import { TextP } from '../../Defaults/Text';
import {
  FlexColCenter,
  FlexBetween,
  FlexRowCenter,
  FlexCol,
} from '../../Defaults/Flexbox/Flexbox';
import { FreeDelivery } from '../../Zemplin/Product/FreeDelivery';
import { Picture } from '../Picture/Picture';
import { DsiSvgIcon, IconType } from '../General/SvgIcon';
import { getImagePath } from '../../../utilities/product';
import { __ } from 'react-i18n';
import { DsiTags as Tags } from '../General/Tags';
import { prop, round } from '../../../utilities';
import { Button } from '../General/Button';

export interface Props {
    serialNumber?: any;
    handleApplyBenefit: any;
}

function SerialNumberTab({
    serialNumber,
    handleApplyBenefit
}: Props) {

  const height = null;
  let picture = prop(serialNumber, 'product.picture');
  let url:string = prop(serialNumber, 'product.publish.0.product_url');
  url = (url && !url.startsWith('/'))?`/${url}`:url;  
  const name = prop(serialNumber, 'product.publish.0.product_name');

  if(picture){
    picture = picture.replace("product/product/","product/");
  }

  return (
    <Wrapper noHeightSet={false} height={"450px"}>
      <UpperWrapper>
        <ImageWrapper>
          <ImageLink to={url}>
            <picture>
              <Image
                loading="lazy"
                alt={`${__('Obrázok ku produktu')} ${name}`}
                src={
                    picture
                      ? getImagePath(picture, { width: 160, height: 160 })
                      : '/images/icons/placeholder.svg'
                }
              />
            </picture>

            
          </ImageLink>
        </ImageWrapper>
        <NameWrapper draggable="false" to={url}>
            <StyledLink to={url}>
                <Name>{`${name}`}</Name>
            </StyledLink>
          
            <StyledLink to={url}>
              <Description>
                {serialNumber.serial_number}
              </Description>
            </StyledLink>
          
        </NameWrapper>
      </UpperWrapper>
      <BottomWrapper>
      {serialNumber?.applied_benefits?.extended_warranty ? (
          <>
            {__('Predĺžená záruka ')}{' '}
            {serialNumber.applied_benefits.extended_warranty.length}{' '}
            {__('mesiacov')}
          </>
        ) : (
          <></>
        )}

        {serialNumber?.available_benefits?.length ? (
          serialNumber.available_benefits.map(availableBenefit => {
            if (availableBenefit.type === 'EXTENDED_WARRANTY') {
              return (
                <Button
                  onClick={() => {
                    handleApplyBenefit(serialNumber.id, availableBenefit.id);
                  }}
                >
                  {' '}
                  {__('Uplatniť predĺženú záruku na ')}{' '}
                  {availableBenefit.benefit.extended_warranty_length}{' '}
                  {__('mesiacov')}
                </Button>
              );
            } else {
              return <></>;
            }
          })
        ) : (
          <></>
        )}
      </BottomWrapper>
    </Wrapper>
  );
}

export const animateIn = keyframes`
   0% {
    opacity: 0;
    transform: scale(0.6) translateY(-8px);
  }
  
  100% {
    opacity: 1;
  }
`;

const ImageWrapper = styled.div`
  display: flex;
  height: 230px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const Wrapper = styled(FlexColCenter)<{
  noHeightSet?: boolean;
  height?: string;
}>`
  animation: ${animateIn} 0.3s ease;
  width: 100%;
  /* max-width: ${rem(252)}; */
  margin: 0 ${rem(16)} ${rem(16)} 0;
  padding: ${rem(16)};
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 1px 4px #00000014;
  border-radius: ${rem(4)};
  position: relative;
  justify-content: space-between;
  max-width: ${rem(448)};
  height: ${props => (props.height ? props.height : '100%')};

  &:hover {
    height: ${({ noHeightSet }) =>
      noHeightSet
        ? props => (props.height ? props.height : '100%')
        : props => (props.height ? props.height : '100%')};
  }
  `;

const OldWrapper = styled(FlexColCenter)`
  animation: ${animateIn} 0.3s ease;
  width: 100%;
  max-width: ${rem(252)};
  margin: 0 ${rem(16)} ${rem(16)} 0;
  padding: ${rem(16)};
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 1px 4px #00000014;
  border-radius: ${rem(4)};
  position: relative;
  justify-content: space-between;

  &:nth-child(4n) {
    margin-right: 0;

    ${({ theme }) => theme.mediab.l1300`
      margin-right: ${rem(16)};
    `}

    ${({ theme }) => theme.mediab.m810`
      margin-right: 0;
      padding-right:  ${rem(8)};
    `}
  }

  &:first-child,
  &:nth-child(2),
  &:first-child > :first-child,
  &:nth-child(2) > :first-child,
  &:nth-child(3) > :first-child,
  &:nth-child(3n) > :nth-child(2) {
    border: 0;
  }
  
  ${({ theme }) => theme.mediab.l1448`
    max-width: 31.8%;

    &:nth-child(4n) {
      margin-right: ${rem(16)};
    }

    &:nth-child(3n) {
      margin-right: 0;
    }
  `}

  ${({ theme }) => theme.mediab.l1148`
    max-width: 48%;
    
    &:nth-child(3n) {
      margin-right: ${rem(16)};
    }
    
    &:nth-child(2n) {
      margin-right: 0;
    }

    &:nth-of-type(3) > :first-child {
      // border-top: ${theme.borders.primary};
    }

    &:nth-child(3n) > :nth-child(2) {
      // border-right: ${theme.borders.primary};
    }

    &:first-child &,
    &:nth-child(2) > :first-child,
    &:nth-child(2n) > :nth-child(2) {
      // border: 0;
    }
  `}

  ${({ theme }) => theme.mediab.s448`
    width: 100%;
    max-width: initial;
    min-width: initial;
    margin-right: 0;
    padding-bottom: ${rem(32)};

    & > :nth-child(2)  {
      // border: 0;
    }

    &:nth-child(2n),
    &:nth-child(3n) {
      margin-right: 0;
    }

    &:first-child &,
    &:nth-child(2) > :first-child,
    &:nth-child(2n) > :nth-child(2) {
      // border-right: 0;
      // border-top: ${theme.borders.primary};
    }

    &:first-child > :nth-child(2), &:nth-child(3n) > :nth-child(2) {
      // border-right: 0;
    }

    &:last-child {
      // border-bottom: ${theme.borders.primary};
    }
  `}
`;

const sharedImage = css`
  margin: ${rem(32)} 0;
  position: relative;
  width: ${rem(144)};
  height: ${rem(144)};
  min-width: ${rem(144)};
  min-height: ${rem(144)};
  transition: height 0.2s ease-in-out;

  /* &:hover {
    transform: scale(0.9);
  } */

  ${Wrapper}:hover & {
    /* transform: scale(0.5); */
    min-height: initial;
    min-width: initial;
    width: auto;
    height: ${rem(96)};
  }
`;

const variantImage = css`
  margin-right: ${rem(8)};
  padding: ${rem(4)};
  position: relative;
  width: ${rem(56)};
  height: ${rem(56)};
  transition: transform 0.2s;
  border: ${({ theme }) => theme.borders.banners};
  border-radius: ${rem(4)};
`;

const firstVariantImage = css`
  margin-right: ${rem(8)};
  padding: ${rem(4)};
  position: relative;
  width: ${rem(56)};
  height: ${rem(56)};
  transition: transform 0.2s;
  border: ${({ theme }) => `1px solid ${theme.colors.successColor}`};
  border-radius: ${rem(4)};
`;

const VariantsWrapper = styled(FlexRowCenter)`
  display: none;
  margin-bottom: ${rem(16)};
  flex-wrap: wrap;

  ${Wrapper}:hover & {
    display: flex;
  }
`;

const VariantsNumber = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: ${rem(56)};
  height: ${rem(56)};
  color: ${({ theme }) => theme.colors.textPrimary};
  line-height: ${rem(16)};
  border: ${({ theme }) => theme.borders.banners};
  background: white;
  cursor: pointer;
`;

const Image = styled.img`
  ${sharedImage}
`;

const ImageLink = styled(Link)``;

const UpperWrapper = styled(FlexColCenter)`
  width: 100%;
`;

const BottomWrapper = styled(FlexColCenter)`
  width: 100%;
  justify-content: space-between;
  margin-bottom: 15px;
`;

const CartWrapper = styled(FlexCol)`
  width: 100%;
`;

const NameWrapper = styled(Link)`
  text-decoration: none;
  width: 100%;
  margin-bottom: ${rem(24)};
`;

const StyledLink = styled(Link)`
  text-decoration: none;
  cursor: pointer;
`;

const Name = styled(TextP)`
  /* height: ${rem(38)}; */
  font-size: ${rem(16)};
  line-height: ${rem(19)};
  margin-bottom: ${rem(8)};
  color: ${({ theme }) => theme.colors.textPrimary};
  text-align: center;
  width: 100%;
  font-weight: 480;
  transition: color 0.2s;
  cursor: pointer;
  -webkit-user-select: text;
  -moz-select: text;
  -ms-select: text;
  user-select: text;

  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;

  &:hover {
    color: ${({ theme }) => darken(0.15, theme.colors.primary)};
  }

  ${({ theme }) => theme.mediab.m810`
      margin-bottom: ${rem(8)};
  `}
`;

const Description = styled(TextP)`
  /* height: ${rem(80)}; */
  color: ${({ theme }) => theme.colors.inactiveFontColor};
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  cursor: pointer;
  -webkit-user-select: text;
  -moz-select: text;
  -ms-select: text;
  user-select: text;
  max-height: ${rem(60)};
  text-overflow: ellipsis;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;

  text-align: center;
  font-size: ${rem(25)};
  margin-top: ${rem(20)};

  ${({ theme }) => theme.mediab.m580`
      height: initial;
  `}
`;

const TagsWrapper = styled(FlexBetween)`
  z-index: 1;
  position: absolute;
  top: ${rem(16)};
  left: ${rem(16)};
  flex-direction: column;

  ${({ theme }) => theme.mediab.m810`
  `}
`;

const FavoriteCompareWrapper = styled.div`
  position: absolute;
  top: ${rem(16)};
  right: ${rem(16)};
  z-index: 1;
`;

export { SerialNumberTab as DsiSerialNumberTab };
